import gql from 'graphql-tag';
export default gql`
  mutation DeleteTextblockById($input: DeleteTextblockByIdInput!) {
    deleteTextblockById(input: $input) {
      deletedTextblockId
    }
  }
`;
